<template>
    <vertical-form-table v-bind="{ items }">
        <template slot="문의내용">
            {{ form.content }}
        </template>
        <template slot="문의답변">
            <div class="ma-n3" style="position: relative">
                <v-textarea v-model="form.reply" v-bind="{ ...attrs_input__verticalTable, loading }" />
                <v-btn absolute top right text tile color="primary" class="mr-n4 mt-n4" v-bind="{ loading }" @click="update"> 저장하기</v-btn>
            </div>
        </template>
    </vertical-form-table>
</template>

<script>
import { attrs_input__verticalTable } from "@/assets/variables";

import VerticalFormTable from "@/components/console/dumb/vertical-form-table.vue";

const initForm = (form = {}) => ({
    ...form,
    reply: form.reply || null,
});

const items = [
    {
        type: "text",
        term: "문의내용",
    },
    {
        key: "reply",
        type: "textarea",
        term: "문의답변",
    },
].map((item) => ({ ...item, headerProps: { class: "pa-2" } }));

export default {
    components: {
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initForm },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        form: initForm(),

        items,
        attrs_input__verticalTable,
    }),
    mounted() {
        this.sync();
    },
    value() {
        this.sync();
    },
    methods: {
        sync() {
            this.form = initForm(this.value);
        },
        update() {
            const { _id, reply } = this.form;
            this.$emit("update", { _id, reply });
        },
    },
};
</script>

<style>
</style>